export default {
	color: {
		dark: '#37323A',
		blue: '#24BECB',
		red: '#EF3E37',
		green: '#84D670',
		light: '#F4F4F4',
		lightGrey: '#D1D1D1',
		grey: '#919191',
		black: '#000000',
	},
	fonts: {
		heading: `'Source Serif Pro', serif`,
		body: 'effra, sans-serif',
		serifBody: 'kepler-std, serif',
	},
	burgerBreakpoint: '768px',
};
